<form [formGroup]="deductionForm">
  <div class="form-row">
    <div [ngClass]="showHoldPaymentColumn ? 'col-2' : 'col-3'">
      <small data-testid="deduction-code">{{ config.Name }}</small>
    </div>

    <div *ngIf="showHoldPaymentColumn" class="col-2">
      <select
        *ngIf="deduction.ThirdPartyPayeeId != null"
        class="form-control ps-2"
        style="text-align: left"
        [(ngModel)]="deduction.HoldThirdPartyDisb"
        (ngModelChange)="onEdit.emit(deduction)"
        [ngModelOptions]="{ standalone: true }">
        <option [ngValue]="false">No</option>
        <option [ngValue]="true">Yes</option>
      </select>
    </div>

    <div [ngClass]="showHoldPaymentColumn ? 'col-2' : 'col-3'">
      <!-- Task 8940: display if calculation rate is not fixed-dollar -->
      <div *ngIf="config.CalculationMethod != deductionCalculations.Fixed" class="text-center">
        <label class="switch">
          <input
            type="checkbox"
            [(ngModel)]="overrideAmount"
            (ngModelChange)="onOverrideChange()"
            [ngModelOptions]="{ standalone: true }" />
          <span
            class="slider-toggle round"
            [ngClass]="config.CalculationMethod == deductionCalculations.Rate ? 'rate-slider' : ''"
            title="Switch to '/hr' to enter a fixed dollar amount"></span>
        </label>
      </div>
    </div>

    <!-- rate/amount -->
    <div class="col-3">
      <div class="input-group">
        <input
          class="form-control"
          (keyup)="onRateAmountChange($event)"
          appNumberInput
          formControlName="rateAmount"
          id="column-4-row-{{ rowIndex }}"
          [attr.disabled]="deductionForm.controls.rateAmount.disabled ? 'disabled' : null"
          data-testid="deduction-rate" />

        <!-- task 8940. if option is set to 'rate' show dollar sign here, else go by calculation method -->
        <div
          class="input-group-prepend"
          *ngIf="
            overrideAmount ||
            (!config.IsPercentageDeduction &&
              config.CalculationMethod != deductionCalculations.Rate)
          ">
          <span class="input-group-text">$</span>
        </div>

        <div class="input-group-append" *ngIf="!overrideAmount && config.IsPercentageDeduction">
          <span class="input-group-text">%</span>
        </div>

        <div
          class="input-group-append"
          *ngIf="!overrideAmount && config.CalculationMethod == deductionCalculations.Rate">
          <span class="input-group-text"><small>/hr</small></span>
        </div>
      </div>
    </div>

    <!-- total/current-amount -->
    <div class="col-3">
      <div class="input-group">
        <input
          class="form-control"
          appNumberInput
          formControlName="total"
          [attr.disabled]="deductionForm.controls.total.disabled ? 'disabled' : null"
          data-testid="deduction-total" />
        <div class="input-group-prepend">
          <span class="input-group-text">$</span>
        </div>
      </div>
    </div>
  </div>
</form>
